import React from "react";
import FlexBox from "schoolUiComponents/basic/Box/FlexBox";
import Text from "schoolUiComponents/basic/Text";
import Image from "../../schoolUiComponents/basic/Image";
import { Colors } from "baseStyles/enums/colors";
import MergeStudentStyles from "./styles";
import { IChild } from ".";
import StringUtility from "utility/string";
import { ImageUtility } from "utility/images";




export const ChildWithImage = ({ child }: { child: IChild }) => {
    const styles = MergeStudentStyles();
    if(!child) {
        return;
    }
  return (
      <FlexBox column padding={12} gap={8} borderRadius={8} backgroundColor={Colors.WHITE} {...styles.childWithImage}>
          {/* @ts-ignore */}
          <Image 
            src={child?.show_gamification_avatar ? child.avatar : (ImageUtility.avatars as any)[`avatars/child-${child.avatar}.png`]} 
            width={64} 
            height={64} 
            borderRadius={child?.show_gamification_avatar ? "50%" : "8px"}
          />
          <FlexBox column gap={4} fullWidth>
              <Text.NORMAL color={Colors.BLACK} emphasis fullWidth lines={2}>{StringUtility.formatFullName(child.first_name, child.last_name)}</Text.NORMAL>
              {!!child?.grade && <Text.SMALL color={Colors.CONTENT_TEXT_SECONDARY}>{child.grade}</Text.SMALL>}
          </FlexBox>
      </FlexBox>
  )
}